module.exports = __webpack_public_path__ + "static/01-1-c570f86b218d96763f8b030d87723626.jpg";